import React, {Component} from 'react';
import {observer} from 'mobx-react';

import Select from 'lib/struct/form/Select';
import Field from 'lib/struct/form/fields/Field';
import Status from 'lib/struct/Status';

import * as MarkupTemplateId from 'settings/constant/MarkupTemplateId';

import GroupsBlockTemplateForm from './template_edit_form/GroupsBlockTemplateForm';
import SimpleGroupTemplateForm from './template_edit_form/SimpleGroupTemplateForm';
import PhotoGroupTemplateForm from './template_edit_form/PhotoGroupTemplateForm';
import ColorGroupTemplateForm from './template_edit_form/ColorGroupTemplateForm';
import BaseStyleForm from './template_edit_form/BaseStyleForm';

@observer export default class MarkupTemplateSettings extends Component {
	render() {
		/** @type {SettingsContext} */
		const context = this.props.context;

		const theme_id = context.current_theme_id;

		if (!context.settings.markup_template_theme_settings.has(theme_id)) {
			return (
				<div>
					<Status status={context.markup_template_loading_state}/>
				</div>
			);
		}

		const markup_settings = context.settings.markup_template_theme_settings.get(theme_id);
		const base_styles_settings = context.settings.base_style_theme_settings.get(theme_id);

		if (!markup_settings || !base_styles_settings) {
			return null;
		}

		const TemplateEditComponent = this.getTemplateEditComponent(context.current_markup_template_id);

		return (
			<div>
				<Field label='Шаблон'>
					<Select
						options={MarkupTemplateId.control_options}
						onChange={e => context.current_markup_template_id = e.target.value}
						value={context.current_markup_template_id}
					/>
				</Field>

				{
					TemplateEditComponent ? (
						<TemplateEditComponent context={context}/>
					) : (null)
				}
			</div>
		);
	}

	getTemplateEditComponent(template_id) {
		if (template_id === MarkupTemplateId.GROUPS_BLOCK) {
			return GroupsBlockTemplateForm;
		} else if (template_id === MarkupTemplateId.SIMPLE_GROUP) {
			return SimpleGroupTemplateForm;
		} else if (template_id === MarkupTemplateId.PHOTO_GROUP) {
			return PhotoGroupTemplateForm;
		} else if (template_id === MarkupTemplateId.COLOR_GROUP) {
			return ColorGroupTemplateForm;
		} else if (template_id === MarkupTemplateId.BASE_STYLES) {
			return BaseStyleForm;
		}
	}
}